'use strict';

function CompanyPublicationBlogService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/publications/:publicationId/posts/:postId', {}, {
    'updatePost': {
      url: config.apiBase + '/companies/:companyId/publications/:publicationId/posts/:postId',
      method: 'PUT'
    }
  });
}

angular.module('dokiv')
  .factory('CompanyPublicationBlogService', ['$resource', 'config', CompanyPublicationBlogService]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/blogs/CompanyPublicationBlogService.js
// module id = 64
// module chunks = 0